import React from 'react';
import { Mail, MessageCircle, Facebook, Instagram, Linkedin, Youtube, ArrowRight } from 'lucide-react';

const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/profile.php?id=61591658203960',
  instagram: 'https://www.instagram.com/bc.behenchara?stkn=ZjZhMW8yeHAwNmFr',
  linkedin: 'https://www.linkedin.com/company/behenchara/',
  youtube: 'https://www.youtube.com/channel/UCfQd2DCY5ov7w3gZn7-QLDQ'
};

const Contact = () => {
  return (
    <div className="bg-ivory min-h-screen" data-testid="contact-page">
      <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <p className="label-editorial">Say Hello</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-8xl leading-[0.95] text-charcoal" data-testid="contact-hero-title">
            Let's <em className="text-burgundy not-italic">connect</em>.
          </h1>
          <p className="text-lg md:text-xl text-charcoal-muted max-w-2xl mx-auto leading-relaxed">
            Questions, feedback, partnerships, or simply a hello — we would love to hear from you.
          </p>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8 border-t border-subtle">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-0 border border-subtle">
          <div className="p-12 border border-subtle -m-px bg-white text-center">
            <Mail className="h-10 w-10 text-burgundy mx-auto mb-6" />
            <p className="label-editorial mb-3">Email Us</p>
            <h3 className="font-serif text-2xl text-charcoal mb-3">For inquiries & partnerships</h3>
            <a href="mailto:hello@behenchara.com" className="text-burgundy hover:underline text-lg" data-testid="contact-email">
              hello@behenchara.com
            </a>
          </div>
          <div className="p-12 border border-subtle -m-px bg-white text-center">
            <MessageCircle className="h-10 w-10 text-burgundy mx-auto mb-6" />
            <p className="label-editorial mb-3">Join The Community</p>
            <h3 className="font-serif text-2xl text-charcoal mb-3">Become part of the sisterhood</h3>
            <a href="/register" className="text-burgundy hover:underline text-lg inline-flex items-center gap-2" data-testid="contact-register-link">
              Register Free <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-charcoal text-ivory">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <p className="label-editorial text-terracotta">Follow the Sisterhood</p>
          <h2 className="font-serif text-3xl md:text-5xl text-ivory">Find us across the world.</h2>
          <div className="flex justify-center space-x-6 pt-4">
            {[
              { icon: Facebook, href: SOCIAL_LINKS.facebook, id: 'facebook' },
              { icon: Instagram, href: SOCIAL_LINKS.instagram, id: 'instagram' },
              { icon: Linkedin, href: SOCIAL_LINKS.linkedin, id: 'linkedin' },
              { icon: Youtube, href: SOCIAL_LINKS.youtube, id: 'youtube' }
            ].map(({ icon: Icon, href, id }) => (
              <a key={id} href={href} target="_blank" rel="noopener noreferrer" className="w-14 h-14 border border-ivory/30 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors" data-testid={`contact-${id}`}>
                <Icon className="h-5 w-5 text-ivory" />
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
